import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button, Modal } from "react-bootstrap";
import { deleteTestEvent } from "../actions";

export class DeleteScheduledEvent extends React.PureComponent {
  handleChangeAction = () => {
    this.props.changeAction(false);
  };

  handleDeleteConfirm = () => {
    const testEventIds = this.props.testEvents
      .keySeq()
      .filter(
        (testEventId) =>
          this.props.testEvents.get(testEventId).get("incompleteFlag") === 1 &&
          !this.props.testEvents.get(testEventId).get("eventStarted")
      );

    this.props.onDeleteTestEvent(testEventIds, this.props.candidateId);
    this.handleChangeAction();
  };

  render() {
    return (
      <div>
        <Modal.Header>
          <h4>Confirmation: Delete Scheduled Test Event</h4>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete this test event?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={this.handleChangeAction}
            id="cancelDeleteScheduled"
            variant="outline-primary"
            className="btn-cancel"
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={this.handleDeleteConfirm}
            id="confirmDeleteScheduled"
          >
            Confirm Delete
          </Button>
        </Modal.Footer>
      </div>
    );
  }
}

DeleteScheduledEvent.propTypes = {
  changeAction: PropTypes.func,
  onDeleteTestEvent: PropTypes.func,
  testEvents: PropTypes.object,
  candidateId: PropTypes.string,
};

const mapDispatchToProps = (dispatch) => ({
  onDeleteTestEvent: (testEventIds, candidateId) =>
    dispatch(deleteTestEvent(testEventIds, candidateId)),
});

export default connect(undefined, mapDispatchToProps)(DeleteScheduledEvent);
